import * as React from 'react';
import { RootState, Dispatch } from '@src/app/_redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { actionCreators } from '@src/app/user/actions';
import { Column } from '@src/app/_global/components/datagrid/types';
import { CustomOrder } from '@CDSGlobal/gc-backend';
import { DescriptionField } from '@src/app/_global/components/datagrid/cell-templates/DescriptionField';
import { SORT_DEF } from '@src/app/_global/components/datagrid/constants';
import { reduxForm } from 'redux-form';
import {
  CurrencyCell,
  DateCell,
} from '@src/app/_global/components/datagrid/cell-templates';
import { getOrdersForMyOrders } from '@src/app/accounts/redux/selectors';
import JsonTable from '@src/app/_global/components/datagrid/datagrid';
import { getRecipsForPopover } from '@src/app/accounts/orders/orderItemUtil';
import {  Popover, PopoverBody } from 'reactstrap';
import { bindActionCreators } from 'redux';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { getCurrencyFormatter } from '@src/app/_global/utility/formatters';
import { withRouter } from 'react-router';
import { getAdminConfigTableItem } from '@src/app/_global/utility/adminConfigUtils';

// export interface PaymentsProps {
//   handleSubmit: any;
//   error: string;
//   submitting: any;
//   dispatch: any;
//   onCancel: any;
//   associatedGifts: any;
//   history: any;
//   intl: intlShape;
//   orderList: any;
// }
export interface PaymentsProps {
  reset: () => void;
  handleSubmit: any;
  intl: intlShape;  
  clientConfig: any;
  adminConfig: any;
  paymentsStart: any;
  onCancel: () => void;
  onChangePaymentAmount: any;
  onChangePaymentType: any;
  onChangeSelectedOrders: any;
  paymentAmount: any;
  orderList: any;
  currentOrder: any;
  associatedGifts: any;
  selectedOrders: CustomOrder[];
  ordersWithBalance: CustomOrder[];
  history: any;
  submitting: any;
  displayError: string;
  availableActions: any;
  autoRenewOptIn: boolean;
  handleAutoRenewCheck: (event: any, order: any) => void;
  directViewLogin: boolean;
}
const PopoverEl = ({ toggle, popoverOpen }) => {
  return (
    <>
      <span className="account-help">
        <i
          onClick={toggle}
          id={'Popover-AccountHelp'}
          className="pointer ml-2 icon-blue fa fa-info-circle fa-1x"
       />
      </span>
      <Popover
        placement="right"
        isOpen={popoverOpen}
        target={'Popover-AccountHelp'}
        toggle={toggle}
        className="account-number-help"
      >
        <PopoverBody>
          <div>
          <span>The amount due today includes only the Installment amount due and not the entire balance.</span>
          </div>
        </PopoverBody>
      </Popover>
    </>
  );
};
function createMarkup(nodeItem: any) {
  return {__html: nodeItem };
}
export class PageOneForm extends React.Component<PaymentsProps> {
  _columns: Column[] = [];
  state: any = {
    filters: [],
    rows: [],
    originalRows: [],
    console: console,
    totalBalanceDue: '0',
    totalAmountDue: '0',
    ordersWithBalance: [],
    paymentAmount: '0',
    popoverOpen: false,
  };

  constructor(props: any, context: any) {
    super(props, context);
 
    this.handleClick = this.handleClick.bind(this);
    this.getSelectedOrders = this.getSelectedOrders.bind(this);
  }

  componentWillMount() {
    const { selectedOrders, availableActions } = this.props;
    let rows = selectedOrders.slice(0);
    let totalBalanceDue = selectedOrders && selectedOrders.reduce((tot, ord) => tot + parseFloat(this.getProductBalance(ord)), 0).toString();
    let totalAmountDue = selectedOrders && selectedOrders.reduce((tot, ord) => 
      tot + parseFloat(availableActions.Preferences.hideInstallmentAmount ?  this.getProductBalance(ord)  : this.getAmountDue(ord)) || 0, 0).toString();
    if (this.state.totalAmountDue === '0' || this.state.totalAmountDue === this.state.totalBalanceDue) {
      this.props.onChangePaymentType('totalBalanceDue');
    }
    this.setState({rows: rows, totalBalanceDue: totalBalanceDue, totalAmountDue: totalAmountDue});
  }
  componentWillReceiveProps({ selectedOrders }: PaymentsProps) {

    let totalBalanceDue = selectedOrders && selectedOrders.reduce((tot, ord) => tot + parseFloat(this.getProductBalance(ord)), 0).toString();
    let totalAmountDue = selectedOrders && selectedOrders.reduce((tot, ord) => 
      tot + parseFloat(this.props.availableActions.Preferences.hideInstallmentAmount ?  this.getProductBalance(ord)  : this.getAmountDue(ord)) || 0, 0).toString();
    this.setState({ totalBalanceDue: totalBalanceDue, totalAmountDue: totalAmountDue});
  }
  // tslint:disable-next-line:member-ordering
  static contextTypes = {
    intl: intlShape,
  };

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen,
    });
  }
  // format table heading labels for i18n
  formatLabels = (messageId, descriptionM, defaultM, context) => {
    const labelText = context.intl.formatMessage({
      id: messageId,
      description: descriptionM,
      defaultMessage: defaultM,
    });
    return labelText;
  }
  // tslint:disable-next-line:member-ordering
  orderDate = this.formatLabels(
    'orders.orddate',
    'this orders init date',
    'Order Date',
    this.context,
  );
  // tslint:disable-next-line:member-ordering
  ordDescription = this.formatLabels(
    'orders.description',
    'order description',
    'Order Description',
    this.context,
  );
  // tslint:disable-next-line:member-ordering
  ordNumber = this.formatLabels(
    'orders.number',
    'order number',
    'Order Number',
    this.context,
  );
  // tslint:disable-next-line:member-ordering
  ordBalance = this.formatLabels(
    'orders.balance',
    'order balance',
    'Balance',
    this.context,
  );
  // tslint:disable-next-line:member-ordering
  ordValue = this.formatLabels(
    'orders.value',
    'order value',
    'Order Value',
    this.context,
  );
    // tslint:disable-next-line:member-ordering
  ordTax = this.formatLabels(
    'orders.tax',
    'order tax',
    'Tax',
    this.context,
  );
  // tslint:disable-next-line:member-ordering
  ordInstallAmtDue = this.formatLabels(
    'orders.installAmtDue',
    'order install amount due',
    'Amount Due',
    this.context,
  );

  loadRecordsIntoState(records: any) {
    const rows = records.slice(0);
    this.state.rows = rows;
  }
  getRecipients(record: any) {
    let thisItems = record.orderItems;
    let recipientNames: any = [];
    let giftAccounts = this.props.associatedGifts.associatedGiftAccounts;
    recipientNames = getRecipsForPopover(record, giftAccounts);
    return recipientNames;
  }

  getRecipLabel(record: any) {
    let isRecip = record.isRecipient;
    const frm = this.formatLabels(
      'gift.from',
      'from label for recieving',
      'From',
      this.context,
    );
    const to = this.formatLabels(
      'gift.to',
      'to label for giving',
      'To',
      this.context,
    );
    let toFrom = isRecip ? frm : to;
    return toFrom;
  }
  getSelectedOrders () {
    return this.props.selectedOrders;
  }
  getProductBalance(order: CustomOrder) {
    if (order.systemCode === 'SERV') {
      return order.totalOrderValue;
    } else {
      if (order.installmentsAllowed === 'Y') {
        if (parseFloat(order.installmentDue) > 0 ) {
          return  order.installmentDue;
        } else {
          return  order.amountDue;
        } 
      } else {
        return order.amountDue;
      }
    }
  }
  getOrderValue(order: CustomOrder) {
    let orderValue;
    if (order.systemCode === 'SERV') {
      orderValue = order.subTotalOrderValue;
    } else {
      orderValue = (order.totalOrderPostageHandling ? Number(order.subTotalOrderValue) + Number(order.totalOrderPostageHandling) :  order.subTotalOrderValue);
    }
    return orderValue.toString();
  }
  getAmountDue(order: CustomOrder) {
    if (order.systemCode === 'SERV') {
      return this.props.availableActions.Preferences.hideInstallmentAmount ?  this.getProductBalance(order)  : order.amountDue;
    } else {
      let productBalance = '0';
      if (order.installmentsAllowed === 'Y') {
        productBalance = this.getProductBalance(order);
        if (parseFloat(order.installmentAmount) < parseFloat(productBalance)) {
          return order.installmentAmount;
        } else {
          return productBalance;
        }
      } else {
        return order.amountDue;
      }
    }
  }
  bindColumns(props: PaymentsProps) {    
    this._columns = [
      {
        key: 'selectedOrder',
        label: '',
        sortable: false,
        width: 50,
        cell: function(order: CustomOrder) {
          let orderSelected = props.selectedOrders.find(ord => ord.orderNumber === order.orderNumber);
          return   (   
            <div className="ml-2 mb-1 select-order">        
            <input
              name="selectOrder"
              id={'selectOrder'}
              type="checkbox"
              checked={orderSelected ? true : false}
              onChange={event => {
                let newValue: CustomOrder[] = [...props.selectedOrders];
                if (event.target.checked) {
                  newValue.push(order);
                } else {
                  newValue.splice(newValue.findIndex(ord => ord.orderNumber === order.orderNumber), 1);
                }
                return props.onChangeSelectedOrders(newValue);
              }}
            /> <label>Pay for this order</label>
            </div>
          );
        },
      },
      {
        key: 'createdDate',
        label: `${this.orderDate}`,
        sortable: true,
        width: 100,
        cell: function(order: CustomOrder) {
          return <DateCell date={order.createdDate} />;
        },
      },
      {
        key: 'productName',
        label: `${this.ordDescription}`,
        sortable: true,
        cell: (order: CustomOrder, state: RootState) => {
          let myRecipients = this.getRecipients(order);
          let recipLabel = this.getRecipLabel(order);
          let availableActions = getAdminConfigTableItem(
            this.props.adminConfig,
            this.props.clientConfig,
            'AvailableActions',
            order.prodIdAlias
          );
          return (
            <>
            <DescriptionField
              order={order}
              recips={myRecipients}
              recipLabel={recipLabel}
              history={this.props.history}
            />
            </>
          );
        },
      },
      {
        key: 'orderNumber',
        label: `${this.ordNumber}`,
        width: 140,
        sortable: true,
      },
      {
        key: 'orderValue',
        width: 110,
        label: `${this.ordValue}`,
        sortable: false,
        cell: (record: CustomOrder) => (
          <CurrencyCell amount={this.getOrderValue(record)} currencyCode={record.systemCode === 'CORE' ? record.currencyCode : 'USD'} />
        ),
      },
      {
        key: 'orderTax',
        width: 90,
        label: `${this.ordTax}`,
        sortable: false,
        cell: (record: CustomOrder) => (
          <CurrencyCell amount={record.taxValue} currencyCode={record.systemCode === 'CORE' ? record.currencyCode : 'USD'} />
        ),
      },
      {
        key: 'totalAmountDue',
        width: 110,
        label: `${this.ordBalance}`,
        sortable: false,
        cell: (record: CustomOrder) => (
          <CurrencyCell amount={this.getProductBalance(record)} currencyCode={record.systemCode === 'CORE' ? record.currencyCode : 'USD'} />
        ),
      },
      {
        key: 'installmentDue',
        width: 120,
        label: `${this.ordInstallAmtDue}`,
        sortable: true,
        cell: (record: CustomOrder) => (
          <CurrencyCell amount={this.getAmountDue(record)} currencyCode={record.systemCode === 'CORE' ? record.currencyCode : 'USD'}/>
        ),
      },

    ];
  }

  handleClick = (evt: React.SyntheticEvent<HTMLInputElement>) => {
    const selectedPmtType = evt.currentTarget.value;
    this.props.onChangePaymentType(selectedPmtType);
    if (selectedPmtType === 'totalBalanceDue') {
      this.props.onChangePaymentAmount(this.state.totalBalanceDue);
    } else {
      this.props.onChangePaymentAmount(this.state.totalAmountDue);
    }
  }
    // format table heading labels for i18n
  formatMessage = (messageId, descriptionM, defaultM, context) => {
    const labelText = context.intl.formatMessage({
      id: messageId,
      description: descriptionM,
      defaultMessage: defaultM,
    });
    return labelText;
  }

  render() {
    const { ordersWithBalance, displayError, directViewLogin } = this.props;
    this.bindColumns(this.props);

    return ordersWithBalance.length > 0 ? (
      <>
        {/* <FormattedMessage
          id="payment.subtitle"
          description="Select orders to pay"
          defaultMessage="Make sure the order(s) you want to pay today are selected."
        /> */}
        <div className="mb-2 mt-2">          
            {displayError && (
              <h5 className="tedanger"><i className="fa fa-exclamation-triangle title fa-2x"></i> {this.props.displayError}</h5>
            )}
          </div>
        <div className="grid-container mb-4">
          <JsonTable
            settings={{ 
              defaultSort: { primary: 'createdDate', secondary: 'productName'},
              sortDir: SORT_DEF.ASC,
              showViewAll: false
            }}
            
            className="responsive-table"
            rows={ordersWithBalance}
            columns={this._columns}
            titleText={''}
            autoRenewOptIn={this.props.autoRenewOptIn}
            handleAutoRenewCheck={this.props.handleAutoRenewCheck}
          />
        </div>

        <form className="payments-form" onSubmit={this.props.handleSubmit} id="payment-page1-form">
        <div>
          <Row>
          <Col xs={12} sm={12} md={6} >
          { this.state.totalAmountDue === '0' || this.state.totalAmountDue === this.state.totalBalanceDue ? 
          (
            <div>
              <span className="bold">Payment amount: {getCurrencyFormatter(this.getSelectedOrders().length > 0 && this.getSelectedOrders()[0].systemCode === 'CORE' 
                                          ? this.getSelectedOrders()[0].currencyCode : 'USD').format(this.state.totalBalanceDue)} </span>
            </div>
          )
          :
          (
            <div>
            <span>For the selected order(s), I would like to pay</span>
            <div className="ml-5">
              <label className="form-check-label">
                <input
                  className="form-check-input"
                  onChange={(e) => this.handleClick(e)}
                  checked={this.props.paymentAmount === this.state.totalBalanceDue}
                  type="radio"
                  name={'paymentAmountType'}
                  value={'totalBalanceDue'}
                />
                The entire balance ({getCurrencyFormatter(this.getSelectedOrders().length > 0 && this.getSelectedOrders()[0].systemCode === 'CORE' 
                                          ? this.getSelectedOrders()[0].currencyCode : 'USD').format(this.state.totalBalanceDue)})
              </label>
              </div >
              <div className="ml-5">
              <label className="form-check-label">
                <input
                  className="form-check-input"
                  onChange={(e) => this.handleClick(e)}
                  checked={this.props.paymentAmount === this.state.totalAmountDue}
                  type="radio"
                  name={'paymentAmountType'}
                  value={'totalAmountDue'}
                />
                  Only the amount due today ({getCurrencyFormatter(this.getSelectedOrders().length > 0 && this.getSelectedOrders()[0].systemCode === 'CORE' 
                                          ? this.getSelectedOrders()[0].currencyCode : 'USD').format(this.state.totalAmountDue)})
              </label>
              <PopoverEl
                    toggle={() => this.toggle()}
                    popoverOpen={this.state.popoverOpen}
                  />
              </div>
          </div>
          )
          }
          </Col>
          </Row>
        </div>
        <div className="button-ct mt-4">
        <button
            className="btn btn-primary "
            type="submit"
            disabled={this.props.submitting || displayError.length > 0}
          >
            <FormattedMessage
              id="app.next"
              description="payment next button"
              defaultMessage="Next"
            />
            <i className="ml-2 fa fa-angle-double-right" aria-hidden="true" />
          </button>
          {!directViewLogin && (
            <button
              className="btn btn-light ml-2"
              type="button"
              onClick={this.props.onCancel}
            >
              <FormattedMessage
                id="app.cancel"
                description="payment cancel button"
                defaultMessage="Cancel"
              />
            </button>
          )}

          </div>
          </form>
      </>
    ) : <span><b>You currently do not have a balance due.</b></span>;
  }
}

let redx = reduxForm({
  form: 'payments-form',
  destroyOnUnmount: false,
  enableReinitialize: false,
  forceUnregisterOnUnmount: true,
})(PageOneForm);

const mapStateToProps = (state: RootState) => ({
  orderList: getOrdersForMyOrders(state),
  loading: state.account.orderData.loading,
  associatedGifts: state.account.associatedGiftAccountsMap || {},
  adminConfig: state.adminConfig,
  clientConfig: state.clientConfig,
  showAllOrders: state.userState.viewAllOrders,
  availableActions: getAdminConfigTableItem(
    state.adminConfig,
    state.clientConfig,
    'AvailableActions',
    state.clientConfig.clientConfig.magCode
  )
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      viewAllOrders: actionCreators.viewAllOrders,
    },
    dispatch,
  );

redx = connect(mapStateToProps, mapDispatchToProps)(redx);

export const PageOne = injectIntl(withRouter(redx));